<template>
  <div class="cadfm-container-horizontal">
            <!--<Left :lang="lang.Left></Left>-->
            <Middle   :lang="lang.Middle"></Middle>
            <!--<Right :lang="lang.Right"></Right>-->
 </div>
</template>

<script>
//import Left from '@/components/PartManager/Views/Categories/Left/Left'
import Middle from "@/components/ProjectManager/Views/Categories/Middle/Middle";
//import Right from '@/components/PartManager/Views/Categories/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: "Categories",
  components: {
    //Left,
    Middle
    //Right
  },
  props: {
    routingData: Object,
    lang: Object
  },
  data() {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    };
  }
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/Categories.vue